import {override} from "mobx";
import {ScoresBarWidgetScoresModel} from "./scores-bar-widget.scores.model";
import {BaseLinkModel} from "../../../../infrastructure/models/link/base-link-model";
import {CompetitorLinkModel} from "../../../../containers/competitor-container/models/competitor-link-model";

export class ScoresBarWidgetAthleteScoresModel extends ScoresBarWidgetScoresModel {
  @override get entityId(): Number {
    return Number(this.currentLinkModel.params.id)
  }

  @override get linkType(): CompetitorLinkModel {
    return CompetitorLinkModel
  }

  @override get linkModel(): BaseLinkModel {
    return null
  }

  @override get shouldRenderLiveToggle(): Boolean {
    return false
  }

  @override get hasDropdown(): Boolean {
    return false;
  }

  @override get shouldRenderDate(): Boolean {
    return false;
  }
}
